import React, { Component } from 'react';
import tr from '../../../libs/tr'
import ReactLoading from 'react-loading';
import './AllMovMinMainPnl.css';
import crdcredit from '../../../images/public/userarea/crdcredit.png';
import alertb from '../../../images/public/userarea/alertb.png';

class AllMovMinMainPnl extends Component {

    constructor(props) {
        super(props);

        this.state = {
            Alert: false,
        };

        this.onClick = this.onClick.bind(this);
    }

    onClick = () => {
        this.props.onClick();
    }

    render() {
      return (
        <div className="allmovmainPnlmin p-3 d-flex align-items-center">
          <div className="container-fluid">
            <div className="row">
              <div className="col-auto d-flex align-items-center justify-content-start pl-lg-5">
                <img src={crdcredit} className="responsiveallmovCardmin" />
              </div>
              <div className="col d-flex align-items-center my-2 my-sm-0">
                <div className="allmovfullNamemin">
                  {tr.t("Seeall")}
                  {
                    this.state.Alert ?
                    <div className="allmovalertbmin">
                      <img src={alertb} className="img-fluid" />
                    </div> : null
                  }
                </div>
              </div>
              <div className="col d-flex align-items-center justify-content-end">
                <button className="arrownBtn" onClick={this.onClick}></button>
              </div>
            </div>   
          </div>
        </div>
      );
    }
}

export default AllMovMinMainPnl;


// WEBPACK FOOTER //
// ./src/assets/components/panel/AllMovMinMainPnl.js